export { isDocument } from './lib/Document';
export * from './lib/FaqCollection';
